import React, { useState } from "react";

import Markdown from "./Markdown";

const MAX_QUESTION_LENGTH = 500;

// Follow-up questions on an explanation. Deliberately knows nothing about grammar
// exercises: give it the initial explanation, a thread (or null), and a URL that accepts
// { question } and returns { thread: { messages: [{ role, content }] } }. The same
// component drops into PlayCollectionV5 with a different askUrl.
// Controlled: the conversation lives in the parent, so hiding and re-showing the
// explanation (which unmounts this) doesn't discard it.
// onAiChecks, optional, gets the learner's updated AI checks from each answer or refusal,
// so a parent showing the count can keep it in step.
export default function ExplanationThread({ explanation, thread, onThreadChange, askUrl, params, onAiChecks }) {
  const messages = (thread || {}).messages || [];
  const [question, setQuestion] = useState("");
  const [asking, setAsking] = useState(false);
  const [error, setError] = useState(null);

  // The stored explanation is the thread's first message once a conversation exists;
  // before that it's shown on its own, so don't render it twice.
  const shown = messages.length > 0 ? messages : [{ role: "assistant", content: explanation }];

  const ask = (e) => {
    if (e) e.preventDefault();
    if (!question.trim() || asking) return;

    setAsking(true);
    setError(null);
    $.ajax({
      method: "post",
      url: askUrl,
      data: { ...params, question: question }
    })
      .done((data) => {
        onThreadChange(data.thread);
        if (onAiChecks && data.aiChecks) onAiChecks(data.aiChecks);
        setQuestion("");
      })
      .fail((xhr) => {
        const json = xhr.responseJSON || {};
        if (onAiChecks && json.aiChecks) onAiChecks(json.aiChecks);
        setError(json.errors ? json.errors[0] : "Couldn't answer that. Please try again.");
      })
      .always(() => setAsking(false));
  };

  return (
    <div className="explanation-thread well well-sm">
      {shown.filter((m) => m.content).map((message, i) => (
        <div key={i} className={`message ${message.role}`}>
          {message.role === "user" ? (
            <p><strong>You:</strong> {message.content}</p>
          ) : (
            <Markdown>{message.content}</Markdown>
          )}
        </div>
      ))}

      <form onSubmit={ask} className="ask">
        <div className="input-group">
          <input
            type="text"
            className="form-control input-sm"
            value={question}
            maxLength={MAX_QUESTION_LENGTH}
            disabled={asking}
            placeholder="Ask a follow-up…"
            onChange={(e) => setQuestion(e.target.value)}
          />
          <span className="input-group-btn">
            <button type="submit" className="btn btn-default btn-sm" disabled={asking || !question.trim()}>
              {asking ? <span className="glyphicon glyphicon-refresh spin" /> : "Ask"}
            </button>
          </span>
        </div>
        {error && <p className="text-danger">{error}</p>}
      </form>
    </div>
  );
}
